import { render, staticRenderFns } from "./WealthView.vue?vue&type=template&id=207bb863&scoped=true"
import script from "./WealthView.vue?vue&type=script&lang=ts"
export * from "./WealthView.vue?vue&type=script&lang=ts"
import style0 from "./WealthView.vue?vue&type=style&index=0&id=207bb863&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bb863",
  null
  
)

export default component.exports